export class Imagem {
  constructor() {
    this.imagens = []
  }

  addImagens(item) {
    this.imagens.push(item)
  }
}
